import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
  isLoading?: boolean
  disabled?: boolean
  className?: string
}

export default function ButtonWrapper({
  children,
  isLoading,
  disabled,
  className = '',
}: Props) {
  return (
    <div
      className={`inline-block 
        ${isLoading || disabled ? 'pointer-events-none' : ''} 
        ${isLoading ? 'opacity-70' : ''} 
        ${disabled ? 'opacity-50 grayscale' : ''} 
        ${className}
      `}
    >
      {children}
    </div>
  )
}
